document.addEventListener("DOMContentLoaded", initLazyVideos);
document.addEventListener("htmx:afterSwap", initLazyVideos);

function initLazyVideos() {
    let lazyVideos = [...document.querySelectorAll("video.nu-lazy")];

    let lazyVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (video) {
            if (!video.isIntersecting) return;
            if (video.target.children.length === 0) return;

            let lazyLoaded = false;
            for (let source in video.target.children) {
                let videoSource = video.target.children[source];

                if (
                    typeof videoSource.tagName !== "string" ||
                    videoSource.tagName !== "SOURCE"
                )
                    continue;

                const lazySrc = videoSource.getAttribute("data-src") || "";

                if (!lazySrc) continue;

                videoSource.setAttribute("src", lazySrc);
                videoSource.removeAttribute("data-src");
                lazyLoaded = true;
            }

            if (!lazyLoaded) return;

            // Fade load in autoplay videos as a nicetie
            if (video.target.hasAttribute("autoplay")) {
                video.target.style.setProperty("opacity", 0);
                video.target.addEventListener(
                    "loadeddata",
                    (e) => {
                        video.target.animate({ opacity: [0, 1] }, 600);
                        video.target.style.removeProperty("opacity");
                    },
                    { once: true },
                );
            }

            video.target.load();
            video.target.classList.remove("nu-lazy");
            lazyVideoObserver.unobserve(video.target);
        });
    });

    lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
    });
}
